import React, { createContext, useEffect, useRef, useState } from "react"

const WidthContext = createContext(null)

const WidthProvider = ({ children }) => {
  const currentWidth = useRef([])
  const initialWidthHeight = () => {
    if (window) return window.innerWidth
    return 0
  }
  const [width, setWidth] = useState(initialWidthHeight())

  useEffect(() => {
    const resizeWidthHandle = () => {
      if (currentWidth.current) {
        if (
          (currentWidth.current < 641 && window.innerWidth > 640) ||
          (currentWidth.current > 640 && window.innerWidth < 641)
        ) {
          currentWidth.current = window.innerWidth
          setWidth(currentWidth.current)
        }
      } else {
        currentWidth.current = window.innerWidth
        setWidth(currentWidth.current)
      }
    }
    resizeWidthHandle()
    let resizeWidthThrottle
    const resizeWidthThrottleFunction = () => {
      if (resizeWidthThrottle) clearTimeout(resizeWidthThrottle)
      resizeWidthThrottle = setTimeout(resizeWidthHandle, 400)
    }

    window.addEventListener("resize", () => resizeWidthThrottleFunction())
    return () =>
      window.removeEventListener("resize", () => resizeWidthThrottleFunction())
  }, [])

  return (
    <WidthContext.Provider value={width > 0 ? width : window.innerWidth}>
      {children}
    </WidthContext.Provider>
  )
}

export { WidthContext, WidthProvider }
